import axios from 'axios'
import {
  SEARCH_USERS_KYC_REQUEST,
  SEARCH_USERS_KYC_SUCCESS,
  SEARCH_USERS_KYC_FAIL,
  GET_PENDING_KYC_REQUEST,
  GET_PENDING_KYC_SUCCESS,
  GET_PENDING_KYC_FAIL,
  GET_KYC_DETAILS_REQUEST,
  GET_KYC_DETAILS_SUCCESS,
  GET_KYC_DETAILS_FAIL,
  UPLOAD_KYC_DOCUMENT_REQUEST,
  UPLOAD_KYC_DOCUMENT_SUCCESS,
  UPLOAD_KYC_DOCUMENT_FAIL,
  SUBMIT_MANUAL_KYC_REQUEST,
  SUBMIT_MANUAL_KYC_SUCCESS,
  SUBMIT_MANUAL_KYC_FAIL,
  APPROVE_MANUAL_KYC_REQUEST,
  APPROVE_MANUAL_KYC_SUCCESS,
  APPROVE_MANUAL_KYC_FAIL,
  REJECT_MANUAL_KYC_REQUEST,
  REJECT_MANUAL_KYC_SUCCESS,
  REJECT_MANUAL_KYC_FAIL,
} from '../constants/manualKYCConstants'

const baseUrl = process.env.REACT_APP_API_URL

// Search users for KYC
export const searchUsersForKYC = (query) => async (dispatch, getState) => {
  try {
    dispatch({ type: SEARCH_USERS_KYC_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/manual-kyc/search?query=${query}`, config)

    dispatch({
      type: SEARCH_USERS_KYC_SUCCESS,
      payload: data.data,
    })
  } catch (error) {
    dispatch({
      type: SEARCH_USERS_KYC_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get pending KYC requests
export const getPendingKYC = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PENDING_KYC_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const queryParams = new URLSearchParams()
    if (filters.page) queryParams.append('page', filters.page)
    if (filters.limit) queryParams.append('limit', filters.limit)
    if (filters.status) queryParams.append('status', filters.status)

    const queryString = queryParams.toString()
    const url = `${baseUrl}/manual-kyc/pending${queryString ? `?${queryString}` : ''}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_PENDING_KYC_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_PENDING_KYC_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get KYC details for a user
export const getKYCDetails = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_KYC_DETAILS_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/manual-kyc/${userId}`, config)

    dispatch({
      type: GET_KYC_DETAILS_SUCCESS,
      payload: data.data,
    })
  } catch (error) {
    dispatch({
      type: GET_KYC_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Upload KYC document
export const uploadKYCDocument = (userId, documentType, extractedData, documentImage) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPLOAD_KYC_DOCUMENT_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/manual-kyc/upload`,
      { userId, documentType, extractedData, documentImage },
      config
    )

    dispatch({
      type: UPLOAD_KYC_DOCUMENT_SUCCESS,
      payload: data,
    })

    return data
  } catch (error) {
    dispatch({
      type: UPLOAD_KYC_DOCUMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    throw error
  }
}

// Submit manual KYC for review
export const submitManualKYC = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUBMIT_MANUAL_KYC_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`${baseUrl}/manual-kyc/submit/${userId}`, {}, config)

    dispatch({
      type: SUBMIT_MANUAL_KYC_SUCCESS,
      payload: data,
    })

    return data
  } catch (error) {
    dispatch({
      type: SUBMIT_MANUAL_KYC_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    throw error
  }
}

// Approve manual KYC
export const approveManualKYC = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: APPROVE_MANUAL_KYC_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/manual-kyc/${userId}/approve`, {}, config)

    dispatch({
      type: APPROVE_MANUAL_KYC_SUCCESS,
      payload: data,
    })

    return data
  } catch (error) {
    dispatch({
      type: APPROVE_MANUAL_KYC_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    throw error
  }
}

// Reject manual KYC
export const rejectManualKYC = (userId, reason) => async (dispatch, getState) => {
  try {
    dispatch({ type: REJECT_MANUAL_KYC_REQUEST })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/manual-kyc/${userId}/reject`, { reason }, config)

    dispatch({
      type: REJECT_MANUAL_KYC_SUCCESS,
      payload: data,
    })

    return data
  } catch (error) {
    dispatch({
      type: REJECT_MANUAL_KYC_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    throw error
  }
}
